var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompareDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cd_cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1792v1080h-1792z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.cd_s0 { fill: none;stroke: #533ffb;stroke-miterlimit:100;stroke-width: 2 } \n\t\t.cd_s1 { fill: #533ffb } \n\t\t.cd_s2 { fill: #bebebe } \n\t\t.cd_s3 { fill: #ebebeb } \n\t\t.cd_s4 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-workspace-task-compare-documents",
    clipPath: "url(#cd_cp1)",
    transform: "translate(-706 -557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 7779cp1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 12348cp1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 13199cp1",
    className: "cd_s0",
    d: "m761.5 581.9h-8.4m12.5 0h-2.1m6.3 0h-2.1m-8.3-10.4h8.3m-12.5 0h2.1m-6.2 0h2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13200cp1",
    fillRule: "evenodd",
    className: "cd_s1",
    d: "m770.8 571.5l-5.2 5.2v-10.4zm-15.6 5.2v10.4l-5.2-5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13201cp1",
    className: "cd_s2",
    d: "m737 581h-31v13.6c0 1.1 0.9 2 2.1 2h26.8c1.1 0 2.1-0.9 2.1-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13202cp1",
    className: "cd_s2",
    d: "m737 568.4v12.6h-31v-22c0-1.1 0.9-2.1 2.1-2.1h17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13203cp1",
    className: "cd_s3",
    d: "m726.1 556.9v9.4c0 1.2 0.9 2.1 2.1 2.1h9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13204cp1",
    className: "cd_s4",
    d: "m731.8 573.6h-19.8c-0.3 0-0.5-0.2-0.5-0.5v-1.1c0-0.3 0.2-0.5 0.5-0.5h19.8c0.3 0 0.5 0.2 0.5 0.5v1.1c0 0.3-0.2 0.5-0.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13205cp1",
    className: "cd_s4",
    d: "m731.8 578.8h-19.8c-0.3 0-0.5-0.2-0.5-0.5v-1.1c0-0.3 0.2-0.5 0.5-0.5h19.8c0.3 0 0.5 0.2 0.5 0.5v1.1c0 0.3-0.2 0.5-0.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13206cp1",
    className: "cd_s4",
    d: "m731.8 584h-19.8c-0.3 0-0.5-0.2-0.5-0.5v-1.1c0-0.3 0.2-0.5 0.5-0.5h19.8c0.3 0 0.5 0.2 0.5 0.5v1.1c0 0.3-0.2 0.5-0.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13207cp1",
    className: "cd_s1",
    d: "m813.2 581h-31v13.6c0 1.1 1 2.1 2.1 2.1h26.8c1.2 0 2.1-1 2.1-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13208cp1",
    className: "cd_s1",
    d: "m813.2 568.4v12.6h-31v-22c0-1.1 1-2.1 2.1-2.1h17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13209cp1",
    className: "cd_s3",
    d: "m802.1 556.9v9.4c0 1.2 0.9 2.1 2 2.1h9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13210cp1",
    className: "cd_s4",
    d: "m807.8 573.6h-19.8c-0.3 0-0.5-0.2-0.5-0.5v-1.1c0-0.3 0.2-0.5 0.5-0.5h19.8c0.3 0 0.5 0.2 0.5 0.5v1.1c0 0.3-0.2 0.5-0.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13211cp1",
    className: "cd_s4",
    d: "m800.3 578.8h-12.5c-0.2 0-0.3-0.2-0.3-0.5v-1.1c0-0.3 0.1-0.5 0.3-0.5h12.5c0.2 0 0.3 0.2 0.3 0.5v1.1c0 0.3-0.1 0.5-0.3 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 13212cp1",
    className: "cd_s4",
    d: "m807.8 584h-19.8c-0.3 0-0.5-0.2-0.5-0.5v-1.1c0-0.3 0.2-0.5 0.5-0.5h19.8c0.3 0 0.5 0.2 0.5 0.5v1.1c0 0.3-0.2 0.5-0.5 0.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareDocuments);
export default __webpack_public_path__ + "static/media/compare-documents.9c0ae952f0690a040e4c9a9f8d5d2d09.svg";
export { ForwardRef as ReactComponent };